import { ExternalLink } from 'lucide-react'
import { cn } from '@/lib/utils'

interface WikidataLinkProps {
  qid: string | null | undefined
  label?: string
  className?: string
}

export function WikidataLink({ qid, label, className }: WikidataLinkProps) {
  if (!qid) return <span className="text-muted-foreground">-</span>

  return (
    <a
      href={`https://www.wikidata.org/wiki/${qid}`}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        'inline-flex items-center gap-1 text-sm text-primary hover:underline',
        className,
      )}
      onClick={(e) => e.stopPropagation()}
    >
      {label || qid}
      <ExternalLink className="h-3 w-3" />
    </a>
  )
}

interface WikidataSearchLinkProps {
  text: string
  className?: string
}

export function WikidataSearchLink({ text, className }: WikidataSearchLinkProps) {
  const searchUrl = `https://www.wikidata.org/w/index.php?search=${encodeURIComponent(text)}`

  return (
    <a
      href={searchUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        'inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-primary hover:underline',
        className,
      )}
      onClick={(e) => e.stopPropagation()}
      title={`Search Wikidata for "${text}"`}
    >
      Search
      <ExternalLink className="h-3 w-3" />
    </a>
  )
}
